export default "__VITE_PUBLIC_ASSET__c4324eac__"